import { Product } from '../..';
import {
  publicOffersAvailableProductsFiltersQuery,
  publicOffersAvailableProductsQuery,
} from '../../../../../../../../store/availableProducts/selectors';
import { publicOffersProductsLoadedState } from '../../../../../../../../store/product/atom';

import { PublicOfferItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const PublicOfferProduct = () => {
  return (
    <Product
      productsQuery={publicOffersAvailableProductsQuery}
      customFiltersQuery={publicOffersAvailableProductsFiltersQuery}
      ProductItem={PublicOfferItem}
      ProductItemLoading={ListLoadingItem}
      atomToSetProductsLoaded={publicOffersProductsLoadedState}
    />
  );
};
